import LocationOnIcon from "@mui/icons-material/LocationOn";
import { Card, Grid, Stack, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Postrequestcall } from "../../request/Postrequest";
import { BIGrey } from "../../assets/helpers";
import Loader from "../../common/Loader";
import { FETCH_CLIENT_EMP_JOBS_2 } from "../../constant/Apipath";
import { ClientEnglishFallback } from "../constant/ClientEnglishFallback";

export default function ClientSiteFiling() {
  const [isLoading, setLoading] = useState(false);
  const { loginData, selectedClientData, multiLanguageData } = useSelector((state) => state?.main);
  const [sortedData, setSortedData] = useState([]);
  const [jobData, setJobData] = useState([]);
  const LANGUAGE = ClientEnglishFallback?.ClientSiteFiling(
    multiLanguageData?.ClientSiteFiling || {}
  );
  const { TEXT_WHEN, TEXT_ADDS_JOB } = LANGUAGE;
  const navigate = useNavigate();

  useEffect(() => {
    fetchJobs();
  }, []);

  const fetchJobs = async () => {
    setLoading(true);
    try {
      let obj = {
        PageNr: 1,
        NrOfRecPerPage: 100,
        FullSearch: "",
        UserId: loginData?.userInformation?.UserId,
        IncludeRecordNr: true,
        FetchAllowedRecordsOnly: true,
        SearchList: [
          {
            clientEmployeeId: selectedClientData?.ClientEmployeeId
          }
        ]
      };

      let res = await Postrequestcall(FETCH_CLIENT_EMP_JOBS_2, obj, loginData?.accessToken);

      if (res?.status === 200) {
        const data = res?.data?.data;
        setJobData(data);
        setLoading(false);
        setSortedData(sortedData);
      }
    } catch (error) {
      console.log("fetchJobs->Error Fetching Client Employee Job: ", error);
    } finally {
      setLoading(false);
    }
  };

  const handelNavigate = (item) => {
    navigate(`${item?.clientJobId}`, { state: item });
  };
  return (
    <>
      {isLoading ? (
        <Loader fullScreen />
      ) : (
        <Grid container spacing={1}>
          {jobData?.length > 0 ? (
            <>
              {jobData?.map((item, index) => {
                return (
                  <Grid key={index} size={12}>
                    <Card
                      onClick={() => {
                        handelNavigate(item);
                      }}
                      sx={{
                        cursor: "pointer",
                        borderRadius: "10px",
                        padding: "10px",
                        boxShadow: "none"
                      }}>
                      <Stack direction="row" spacing={1}>
                        <LocationOnIcon
                          sx={{
                            color: selectedClientData?.AccentColor
                          }}
                        />
                        <Typography>{`${item?.jobCode} - ${item?.jobName}`}</Typography>
                      </Stack>
                    </Card>
                  </Grid>
                );
              })}
            </>
          ) : (
            <>
              <Stack sx={{ justifyContent: "center", alignItems: "center" }} height={"80vh"} width={"100%"}>
                <Typography
                  sx={{
                    color: BIGrey
                  }}>
                  {TEXT_WHEN} {selectedClientData?.OrganizationName} {TEXT_ADDS_JOB}
                </Typography>
              </Stack>
            </>
          )}
        </Grid>
      )}
    </>
  );
}
